module.exports = __webpack_public_path__ + "static/media/fondo-home-hoteles.9e918c01.jpg";